var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupTitleIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit alt 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secondary (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5535 12.2401C81.772 11.7324 83.0791 11.471 84.3992 11.471C85.7193 11.471 87.0264 11.7324 88.245 12.2401C89.46 12.7463 90.5631 13.4873 91.491 14.4207L105.579 28.5083C106.512 29.4362 107.253 30.5393 107.759 31.7542C108.267 32.9728 108.528 34.2798 108.528 35.6C108.528 36.9201 108.267 38.2272 107.759 39.4458C107.253 40.6606 106.512 41.7636 105.579 42.6915C105.576 42.6943 105.573 42.6972 105.57 42.7L91.1848 57.0855C90.2471 58.0232 88.9753 58.55 87.6492 58.55C86.3231 58.55 85.0514 58.0232 84.1137 57.0855L62.9137 35.8855C61.976 34.9479 61.4492 33.6761 61.4492 32.35C61.4492 31.0239 61.976 29.7521 62.9137 28.8145L77.3077 14.4205C78.2356 13.4872 79.3386 12.7462 80.5535 12.2401ZM73.5203 32.35L87.6492 46.4789L98.5282 35.6L98.5136 35.5856L84.3992 21.471L84.3848 21.4856L73.5203 32.35Z",
    fill: "#CDE1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8145 42.9145C50.7671 40.9619 53.9329 40.9619 55.8855 42.9145L77.0855 64.1145C79.0382 66.0671 79.0382 69.2329 77.0855 71.1855L39.7355 108.536C38.7979 109.473 37.5261 110 36.2 110H15C12.2386 110 10 107.761 10 105V83.8C10 82.4739 10.5268 81.2022 11.4645 80.2645L48.8145 42.9145ZM20 85.8711V100H34.1289L66.4789 67.65L52.35 53.5211L20 85.8711Z",
    fill: "#0E6AF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupTitleIcon1);
export default __webpack_public_path__ + "static/media/sup_title_icon1.554feb64166463e3cdbb4baf7abd79c2.svg";
export { ForwardRef as ReactComponent };